<template>
  <svg
    :width="svgWidth"
    :height="svgHeight"
    :viewBox="`0 0 ${svgWidth} ${svgHeight}`"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="icon-battery"
  >
    <!-- Battery body -->
    <rect
      :x="svgWidth * 0.0417"
      :y="svgHeight * 0.1667"
      :width="svgWidth * 0.8333"
      :height="svgHeight * 0.6667"
      :rx="svgWidth * 0.0625"
      :stroke="bodyColor"
      :stroke-width="svgWidth * 0.0417"
      :fill="bodyFill"
    />
    <!-- Battery tip -->
    <rect
      :x="svgWidth * 0.875"
      :y="svgHeight * 0.375"
      :width="svgWidth * 0.0833"
      :height="svgHeight * 0.25"
      :rx="svgWidth * 0.0208"
      :fill="tipColor"
    />
    <!-- Battery levels -->
    <rect
      v-if="battery > 0"
      :x="svgWidth * 0.125"
      :y="svgHeight * 0.2917"
      :width="svgWidth * 0.1667"
      :height="svgHeight * 0.4167"
      :rx="svgWidth * 0.0208"
      :fill="batteryColor"
    />
    <rect
      v-if="battery > 1"
      :x="svgWidth * 0.375"
      :y="svgHeight * 0.2917"
      :width="svgWidth * 0.1667"
      :height="svgHeight * 0.4167"
      :rx="svgWidth * 0.0208"
      :fill="batteryColor"
    />
    <rect
      v-if="battery > 2"
      :x="svgWidth * 0.625"
      :y="svgHeight * 0.2917"
      :width="svgWidth * 0.1667"
      :height="svgHeight * 0.4167"
      :rx="svgWidth * 0.0208"
      :fill="batteryColor"
    />
  </svg>
</template>

<script>
export default {
  name: "BatteryIcon",
  props: {
    battery: {
      type: Number,
      default: 3,
      validator: v => [0, 1, 2, 3].includes(v)
    },
    width: {
      type: Number,
      default: 24
    },
    height: {
      type: Number,
      default: 12
    }
  },
  computed: {
    svgWidth() {
      return this.width;
    },
    svgHeight() {
      return this.height;
    },
    batteryColor() {
      switch (this.battery) {
        case 1:
          return "#ffb300";
        case 2:
          return "#ffee58";
        case 3:
          return "#43a047";
        default:
          return "#e0e0e0";
      }
    },
    bodyColor() {
      return this.battery === 0 ? "#e53935" : "#333";
    },
    tipColor() {
      return this.battery === 0 ? "#e53935" : "#333";
    },
    bodyFill() {
      return this.battery === 0 ? "#ffcdd2" : "#fff";
    }
  }
};
</script>

<style scoped lang="scss">
.icon-battery {
  user-select: none;
  pointer-events: none;
}
</style>
